import { useState, useEffect } from 'react'
import { useTelevetEmbeddedLink } from '@/shared/hooks/queries/use-televet-embedded-link'
import { sendEvent } from '@/shared/hooks/use-analytics'

export function useTelevetPage() {
  const { data: televetUrl, isLoading } = useTelevetEmbeddedLink()
  const [showTelevetIframe, setShowTelevetIframe] = useState(false)
  const [chatButtonPressed, setChatButtonPressed] = useState(false)

  useEffect(() => {
    if (chatButtonPressed && !isLoading && televetUrl) {
      setChatButtonPressed(false)
      setShowTelevetIframe(true)
      sendEvent('televet_opened', { source: 'client_app' })
    }
  }, [chatButtonPressed, isLoading, televetUrl])

  function openTelevetIframe() {
    if (televetUrl) {
      setShowTelevetIframe(true)
      sendEvent('televet_opened', { source: 'client_app' })
    } else {
      setChatButtonPressed(true)
    }
  }

  function closeTelevetIframe() {
    setShowTelevetIframe(false)
    sendEvent('televet_closed', { source: 'client_app' })
  }

  return {
    televetUrl,
    chatButtonLoading: chatButtonPressed && isLoading,
    showTelevetIframe,
    openTelevetIframe,
    closeTelevetIframe,
  }
}
